import defaultAttributes from '../defaultAttributes';

const CornerLeftDown = [
  'svg',
  defaultAttributes,
  [
    ['polyline', { points: '14 15 9 20 4 15' }],
    ['path', { d: 'M20 4h-7a4 4 0 00-4 4v12' }],
  ],
];

export default CornerLeftDown;
